// src/reports/registry.js
export const REPORTS = [
  {
    slug: "organization-user-report",
    titleKey: "reports.orgUserReportTitle",
    categoryKey: "reports.categoryAdministration",
    roles: ["superuser"],
    path: "/app/reports/organization-user-report",
  },
  {
    slug: "user-test-export",
    titleKey: "reports.basicTestDataTitle",
    categoryKey: "reports.categoryDataExport",
    roles: ["admin", "superuser", "pro_user", "user"],
    path: "/app/reports/user-test-report",
  },
];
